<template>
  <WidgetTestContainer>
    <script type="text/x-epodroznik-module" data-module-name="SearchingResults"
            id="SearchingResults"></script>
    <div ref="content"></div>
  </WidgetTestContainer>
</template>

<script>
  import '../assets/less/style-account.less'
  import WidgetTestContainer from '../components/WidgetTestContainer'

  export default {
    components: {
      WidgetTestContainer
    },
    mounted() {
      const scriptMain = document.createElement('script')
      scriptMain.setAttribute('type', 'text/javascript')
      scriptMain.setAttribute('src', 'https://www.e-podroznik.pl/public/jslib.do')

      this.$refs['content'].appendChild(scriptMain)

    }
  }
</script>

<style lang="less">

</style>
